import { useEffect } from 'react';

import { useMissingDataHeader } from '@/context/MissingDataHeaderProvider';

type Catalog = {
  columns?: ({ name: string | null } | null)[] | null;
};

export type CatalogAppliedData = {
  catalog: Catalog | null;
};

export const useSetMissingCatalog = (
  appliedData: CatalogAppliedData | null | undefined,
) => {
  const { setMissingCatalogInfo } = useMissingDataHeader();

  useEffect(() => {
    const isMissingCatalogInfo =
      !!appliedData && (appliedData.catalog?.columns?.length ?? 0) === 0;
    setMissingCatalogInfo(isMissingCatalogInfo);
    return () => {
      setMissingCatalogInfo(false);
    };
  }, [setMissingCatalogInfo, appliedData]);
};
